import { render, staticRenderFns } from "./HedgehogClassifier.vue?vue&type=template&id=789b76a7&scoped=true&"
import script from "./HedgehogClassifier.vue?vue&type=script&lang=js&"
export * from "./HedgehogClassifier.vue?vue&type=script&lang=js&"
import style0 from "./HedgehogClassifier.vue?vue&type=style&index=0&id=789b76a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b76a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VProgressCircular,VSpacer,VToolbar})
